module.exports = __webpack_public_path__ + "static/media/mines_logo.d10c40ae.png";